import { useEffect } from "react";
import { useResizeDetector } from "react-resize-detector";

// Custom hook to callback RGL parent with calculated height in grid units

const calculateHeight = (height: number, padding: number, margin: number, gridRowHeight: number) =>
  Math.ceil((height + 5 + padding) / (gridRowHeight + margin));

export const useDynamicHeight = ({
  nodeHeightCallback,
  uuid,
  gridRowHeight,
  padding = 0,
  margin = 10,
}: {
  nodeHeightCallback: (uuid: string, height: number) => void;
  uuid: string;
  gridRowHeight: number;
  padding?: number;
  margin?: number;
}) => {
  const { ref, height } = useResizeDetector({ onResize: () => {} });
  useEffect(() => {
    if (height) {
      // RGL sets a default margin of margin: ?[number, number] = [10, 10],
      // Here we calculate pixel height to grid units
      nodeHeightCallback(uuid, calculateHeight(height, padding, margin, gridRowHeight));
    }
  }, [gridRowHeight, height, margin, nodeHeightCallback, padding, uuid]);
  return { ref, height };
};
